import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.TrackingCategoriesFormPart', {
    cutsetPlaceholder: 'Select {name}',
    doNotFilterValue: 'Do Not Filter',
    unassignedValue: 'Unassigned',
    notEmptyValue: 'All {fieldName}',
});
